import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import {
  selectCurrentNavPage,
  selectCurrentOrganization,
  selectUserOrganizations,
  selectRouting,
  selectLoggedAs
} from "Selectors";
import { setCurrentOrganization, fetchErpData } from "Thunks";
import { setAuth, setSwitchSpace, setLanguage } from "Actions";
import _ from "i18n";

import { Header } from "tamtam-components";
import {
  clearAllCookies,
  redirectToHome,
  setLocalStorageCookie,
  setCookie,
  getCookie,
  inIframe
} from "Utils";
import {
  APP_ENV,
  TTP_EMAILING_URL,
  TTP_HOME_URL,
  TTP_POWER_TEAM_URL
} from "../../config";

export class Menu extends Component {
  constructor(props) {
    super(props);
    const cookie = getCookie("SWITCH_USER_TEAM");
    console.log("cookie", cookie);
    if (this.props.loggedAs === "SUPERADMIN")
      this.props.dispatch(setSwitchSpace("SUPERADMIN"));
    if (this.props.loggedAs === "ADMIN")
      this.props.dispatch(setSwitchSpace("ADMIN"));
    if (this.props.loggedAs === "MANAGER")
      if (cookie) this.props.dispatch(setSwitchSpace(cookie));
    this.state = {
      switchUser: cookie ? cookie : "MANAGER",
      idUserExist: false
    };
  }

  handleSetCurrentOrganization = organization => {
    this.props.dispatch(setCurrentOrganization(organization)).then(() => {
      this.props.dispatch(fetchErpData());
    }, err => err);
    setTimeout(() => this.props.dispatch(push("/")), 500);
  };
  handleRedirectTo = to => {
    this.props.dispatch(push(to));
  };

  componentDidMount() {
    /* const { currentOrganization, routing, loggedAs, dispatch } = this.props;

    let flag = false;
    [
      "/collaborator-space",
      "/collaborator-calendar",
      "/collaborator-folders"
    ].forEach(item => {
      let matcher = new RegExp("^" + item.toLowerCase() + "*", "g");
      if (matcher.test(routing.location.pathname)) {
        flag = true;
      }
    });
*/
    /*   if (
      currentOrganization.authorisation &&
      ["MANAGER", "SUPERVISOR"].includes(
        currentOrganization.authorisation.role
      ) &&
      (loggedAs === "MANAGER" || loggedAs === "SUPERVISOR") &&
      flag
    ) {
      dispatch(setAuthLoggedAs("COLLABORATOR"));
    }*/
  }

  render() {
    const {
      loggedAs,
      user,
      userOrganizations,
      currentOrganization,
      appsState,
      lng,
      token,
      dispatch
    } = this.props;

    // const currentMenus = MENUS[loggedAs];

    //  let hideMenu = HIDDEN_MENU_PAGES.indexOf(currentNavPage) !== -1;

    let portalConfig =
      appsState && appsState.filter(app => app.code === "portal");

    let settingEnabled =
      loggedAs === "MANAGER" ||
      (user && (user.type === "ADMIN" || user.type === "ADMIN_SUPERVISOR"));

    const settings = settingEnabled
      ? [
          {
            label: _("categorySettings"),
            url: "/category-settings"
          },
          {
            label: _("taskTypesSettings"),
            url: "/task-types"
          },
          {
            label: _("collaboratorsSettings"),
            url: "/collaborators-settings"
          },
          {
            label: _("calendarSettings"),
            url: "/calendar-settings"
          },
          {
            label: _("parameterSettings"),
            url: "/parameter-settings"
          },
          {
            label: _("users"),
            url: "/authorizations"
          }
        ]
      : [];
    const switchSpace = {
      items: [
        {
          key: "COLLABORATOR",
          label: "Espace Collaborator"
        },
        {
          key: "MANAGER",
          label: "Espace Manager"
        }
      ],
      current: this.state.switchUser,
      onChange: user => {
        if (user === "COLLABORATOR") {
          dispatch(push("/collaborator-space"));
        } else {
          dispatch(push("/"));
        }
        this.setState({ ...this.state, switchUser: user });
        this.setCookieSwitchUser(user);
        dispatch(setSwitchSpace(user));
      }
    };
    const rightIcons = {
      ebox: { activated: true, icon: "Ebox", url: `${TTP_EMAILING_URL}e_box` },
      notifs: { activated: true },
      faq: { activated: true },
      apps: {
        activated: true
      },
      home: {
        activated: true,
        icon: "Portal",
        url: portalConfig && portalConfig[0] && portalConfig[0].url
      },
      profile: {
        activated: true,
        url: `${TTP_HOME_URL}/profile`,
        icon: "Profile"
      },
      search: { activated: false }
    };
    /* return !this.props.withoutHeader ? (
      <header id="mainMenu">
        <div className="top-bar" id="animated-menu">
          <LeftSide
            handleSetCurrentOrganization={this.handleSetCurrentOrganization}
            handleRedirectTo={this.handleRedirectTo}
          />
          <RightSide />
        </div>
      </header>
    ) : (
      ""
    );*/

    if (!user || !user.id) {
      return !this.props.withoutHeader && !inIframe() ? (
        <Header
          app={{
            appName: "PowerTeam",
            appLogoUrl: "https://s3.tamtam.pro/prod/apps/powerteam.png",
            appUrl: "/",
            homeUrl: "/"
          }}
          auth={{ navCommunity: null, user: null }}
          lng={lng}
          env={APP_ENV}
          onLanguageChange={lang => this.changeLng(lang)}
          rightIcons={rightIcons}
          onSelectCommunity={community => this.selectCommunity(community)}
        />
      ) : (
        ""
      );
    }
    return !this.props.withoutHeader && !inIframe() ? (
      <Header
        auth={{
          token,
          navCommunity: currentOrganization,
          user: {
            ...user,
            communities: userOrganizations
          }
        }}
        env={APP_ENV}
        switchSpace={loggedAs === "MANAGER" ? switchSpace : ""}
        lng={lng}
        onLanguageChange={lang => this.changeLng(lang)}
        rightIcons={rightIcons}
        app={{
          appName: "PowerTeam",
          appLogoUrl: "https://s3.tamtam.pro/prod/apps/powerteam.png",
          appUrl: `${TTP_POWER_TEAM_URL}`,
          homeUrl: "/"
        }}
        settings={loggedAs === "MANAGER" ? settings : ""}
        onLogoutClick={e => this.handleLogout(e)}
        onSelectCommunity={community => this.selectCommunity(community)}
      />
    ) : (
      ""
    );
  }

  selectCommunity = community => {
    this.props.dispatch(setCurrentOrganization(community)).then(() => {
      this.props.dispatch(push("/"));
    });
  };
  handleLogout = e => {
    const { dispatch } = this.props;
    e.preventDefault();
    dispatch(setAuth(null));
    setLocalStorageCookie(null);

    clearAllCookies(redirectToHome);
  };

  changeLng = e => {
    const { dispatch } = this.props;
    dispatch(setLanguage(e));
    window.location.reload();
  };

  setCookieSwitchUser = user => {
    const dtExpire = new Date();
    dtExpire.setTime(dtExpire.getTime() + 86400 * 1000 * 3); //3j
    setCookie(`SWITCH_USER_TEAM`, user, dtExpire, "/", "tamtam.pro");
  };
}

// Connected Component
const mapStateToProps = state => ({
  user: state.auth.user,
  embedded: state.params.embedded,
  userOrganizations: selectUserOrganizations(state),
  currentOrganization: selectCurrentOrganization(state),
  currentNavPage: selectCurrentNavPage(state),
  routing: selectRouting(state),
  loggedAs: selectLoggedAs(state),
  lng: state.params.lng,
  token: state.auth.token,
  count: state.params.countTaskType.count,
  appsState:
    state.auth.currentOrganization && state.auth.currentOrganization.appsState,
  withoutHeader: state.auth.withoutHeader,
  withoutMenu: state.auth.withoutMenu
});

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/Menu/index.js